// Initialize slick-carousel
$('.slick-carousel-initialize').slick({
    nextArrow: '<button type="button" class="slick-next"><span class="fa-layers"><i class="fal fa-angle-right slick-next-shadow" data-fa-transform="left-1"></i><i class="fal fa-angle-right"></i></span></button>',
    prevArrow: '<button type="button" class="slick-prev"><span class="fa-layers"><i class="fal fa-angle-left slick-prev-shadow" data-fa-transform="right-1"></i><i class="fal fa-angle-left"></i></span></button>',
    dots: true,
    adaptiveHeight: true
})

// This is a workaround to enable gradient layers with correct slide width
$('.slick-carousel-initialize').on('setPosition', function(event, slick) {
    $('.slick-slider-gradient').each(function() {
        $(this).remove();
    });
    // 'slick.listWidth' is only possible if one slide is shown, if there are multible slides shown we would need the width of each
    $('head').append('<style class="slick-slider-gradient">.slick-carousel-initialize .slide.gradient::before{width:' + slick.listWidth + 'px !important;}</style>')
})